module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA4AQMAAAAGrgCvAAAAA1BMVEUGBgYczkPbAAAAAXRSTlMfze7VkwAAAAtJREFUCB1joDMAAABwAAFxZGi7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/b_line.png
// module id = tKqR
// module chunks = 37